import { LegalNoteLink, nextLine } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  address: `
    FGW e.V. - Fördergesellschaft Windenergie und andere Dezentrale Energien
    ${nextLine()}Oranienburger Str. 45
    ${nextLine()}10117 Berlin
  `,
  contact: "Contact",
  footerTitle: "FGW e.V. - Fördergesellschaft Windenergie und andere Dezentrale Energien",
  copyrightString: "© 2024 FGW e.V. All rights reserved.",
  eMail: "info@zerez.net",
  eula: "EULA",
  faq: "FAQ",
  fundedBy: "Funded by (Funding code: 03MAP427)",
  fundingCode: "Funding code: 03MAP427",
  imprint: "Imprint",
  officiallyAppointed: `FGW e. V. has been ${LegalNoteLink({
    url: "https://www.bundesanzeiger.de/pub/publication/ghCqAifY5ZGYr6EK5bX/content/ghCqAifY5ZGYr6EK5bX/BAnz%20AT%2013.03.2025%20B1.pdf?inline",
    ariaLabel: "Link to",
    label: "officially appointed",
  })} by the Federal Republic of Germany.`,
  phone: "+49 (0)30 / 30 10 15 05-0",
  privacyPolicy: "Privacy Policy",
  runBy: "Run By",
  contactTooltip: "We look forward to your message!",
  downloadFileTooltip: "Download file",
};
